import { DefaultError } from 'errors/DefaultError';

export class MoveInPreSSDError extends DefaultError {
  constructor(error) {
    super({
      error: new Error(JSON.stringify(error)),
      name: MoveInPreSSDError.name,
      title: 'We didn’t supply the property on the day you moved',
      message: ''
    });
  }

  static get name() {
    return 'MoveInPreSSDError';
  }
}
